<template>
  <v-container>
    <!-- BOC:[breadcrumbs] -->
    <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
    <!-- EOC -->
    <v-card>
      <v-card-title>Reports</v-card-title>
      <v-card-text>
        <v-tabs v-model="activeTab">
          <v-tab>Schools</v-tab>
          <v-tab>Events</v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab">
          <!-- Schools Tab Content -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div class="d-flex d-xs-block align-start">
                  <div class="flex-grow-1">
                    <v-row>
                      <v-col>
                        <v-select
                          v-model="selectedState"
                          :items="states"
                          label="State"
                          :disabled="disableSelectState"
                        ></v-select>
                      </v-col>
                      <v-col>
                        <v-select
                          v-model="selectedInsitutionType"
                          :items="institutionTypes"
                          label="Type of School"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </div>
                  <v-btn
                    rounded
                    color="success"
                    class="ml-2"
                    @click="fetchInstitutions"
                    :loading="api.isLoading"
                    >Find</v-btn
                  >
                </div>
                <div v-if="api.isLoading">
                  <v-skeleton-loader type="table"></v-skeleton-loader>
                </div>
                <div v-else-if="api.isError">
                  <v-alert type="error">{{ api.error }}</v-alert>
                </div>
                <div v-else-if="api.data">
                  <!-- School reports content will go here -->
                  <v-card class="mb-4" outlined>
                    <v-card-title>Summary</v-card-title>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>Item</th>
                          <th class="text-right">Count</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Schools</td>
                          <td class="text-right">
                            {{ api.data.count.institution }}
                          </td>
                        </tr>
                        <tr>
                          <td>Students</td>
                          <td class="text-right">
                            {{ api.data.count.student }}
                            <div class="text-caption">
                              <i
                                >(From
                                {{
                                  api.data.count.institutionWithStudents
                                }}
                                Schools)</i
                              >
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                  <v-card outlined>
                    <v-card-title>Schools</v-card-title>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th class="text-right">Students</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="school in api.data.data" :key="school.name">
                          <td>{{ school.name }}</td>
                          <td class="text-right">
                            {{ school.activeStudentCount }}
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- Events Tab Content -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div class="d-flex d-xs-block align-start">
                  <div class="flex-grow-1">
                    <v-row>
                      <v-col>
                        <v-select
                          v-model="selectedEvent"
                          :items="events"
                          label="Event"
                        ></v-select>
                      </v-col>
                      <v-col>
                        <v-select
                          v-model="selectedState"
                          :items="states"
                          label="State"
                          :disabled="disableSelectState"
                        ></v-select>
                      </v-col>
                      <v-col>
                        <v-select
                          v-model="selectedInsitutionType"
                          :items="institutionTypes"
                          label="Type of School"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </div>
                  <v-btn
                    rounded
                    color="success"
                    class="ml-2"
                    @click="fetchEventReport"
                    :loading="apiEventReport.isLoading"
                    >Find</v-btn
                  >
                </div>
                <div v-if="apiEventReport.isLoading">
                  <v-skeleton-loader type="table"></v-skeleton-loader>
                </div>
                <div v-else-if="apiEventReport.isError">
                  <v-alert type="error">{{ apiEventReport.error }}</v-alert>
                </div>
                <div v-else-if="apiEventReport.data">
                  <!-- Event reports content will go here -->
                  <v-card class="mb-4" outlined>
                    <v-card-title>Summary</v-card-title>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>Item</th>
                          <th class="text-right">Count</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Schools</td>
                          <td class="text-right">
                            {{ apiEventReport.data.length }}
                          </td>
                        </tr>
                        <tr>
                          <td>Students</td>
                          <td class="text-right">
                            {{ $_.sumBy(apiEventReport.data, "student") }}
                            <div class="text-caption">
                              <!-- <i
                                >(From
                                {{ apiEventReport.data.length }} Schools)</i
                              > -->
                            </div>
                          </td>
                        </tr>
                         <tr>
                          <td>Players</td>
                          <td class="text-right">
                            {{ $_.sumBy(apiEventReport.data, "player") }}
                          </td>
                        </tr>
                        <tr>
                          <td>Participants</td>
                          <td class="text-right">
                            {{ $_.sumBy(apiEventReport.data, "participant") }}
                          </td>
                        </tr>
                        <tr>
                          <td>Qualifiers(15+ Stars)</td>
                          <td class="text-right">
                            {{ $_.sumBy(apiEventReport.data, "qualifiers") }}
                          </td>
                        </tr>
                        <tr>
                          <td>Finishers</td>
                          <td class="text-right">
                            {{ $_.sumBy(apiEventReport.data, "finisher") }}
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card>

                  <v-card outlined>
                    <v-card-title>Schools</v-card-title>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th class="text-right">Students</th>
                           <th class="text-right">Players</th>
                          <th class="text-right">Participants</th>
                          <th class="text-right">Qualifiers(15+ Stars)</th>
                          <th class="text-right">Finishers</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="school in apiEventReport.data"
                          :key="school.name"
                        >
                          <td>{{ school.name }}</td>
                          <td class="text-right">{{ school.student }}</td>
                          <td class="text-right">{{ school.player }}</td>
                          <td class="text-right">{{ school.participant }}</td>
                          <td class="text-right">{{ school.qualifiers }}</td>
                          <td class="text-right">{{ school.finisher }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  components: {
    //
  },
  computed: {
    //
  },
  props: [
    //
  ],
  data: () => ({
    //BOC:[breadcrumbs]
    breadcrumbs: [],
    //EOC
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
      data: null,
    },
    //EOC
    //BOC:[apiState]
    apiState: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    //BOC:[apiEvent]
    apiEvent: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    //BOC:[apiEventReport]
    apiEventReport: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    //BOC: [tab]
    activeTab: 0,
    //EOC
    governmentInstitution: null,
    disableSelectState: false,
    selectedState: null,
    selectedInsitutionType: null,
    selectedEvent: null,
    states: [],
    events: [],
    institutionTypes: [
      { text: "All", value: null },
      { text: "Public Schools", value: "public" },
      { text: "Private Schools", value: "private" },
      { text: "Enrichment Centers", value: "enrichment" },
    ],
  }),
  created() {
    this.breadcrumbs = [
      {
        text: "Dashboard",
        to: { name: "PageEducatorDashboard" },
        exact: true,
      },
      {
        text: "My Institution",
        to: {
          name: "PageEducatorInstitutionDashboard",
          params: { id: this.$route.params.id },
        },
        exact: true,
      },
      {
        text: "Reports",
        to: {
          name: "PageEducatorInstitutionReport",
          params: { id: this.$route.params.id },
        },
        exact: true,
      },
    ];
    //
    //BOC: [api]
    this.url = this.api.url =
      this.$api.servers.sso +
      "/api/v1/" +
      this.$_getLocale() +
      "/moderator/report/institution/activeParticipatingInstitution/getCountByState";

    this.api.method = "POST";
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.api.data = resp;
    };
    //EOC
    //BOC: [apiEventReport]
    this.url = this.apiEventReport.url =
      this.$api.servers.sso +
      "/api/v1/" +
      this.$_getLocale() +
      "/moderator/report/event/getCountByInstitution";

    this.apiEventReport.method = "POST";
    this.apiEventReport.callbackReset = () => {
      this.apiEventReport.isLoading = true;
      this.apiEventReport.isError = false;
    };
    this.apiEventReport.callbackError = (e) => {
      this.apiEventReport.isLoading = false;
      this.apiEventReport.isError = true;
      this.apiEventReport.error = e;
    };
    this.apiEventReport.callbackSuccess = (resp) => {
      this.apiEventReport.isLoading = false;
      this.apiEventReport.data = resp;
    };
    //EOC
    //BOC: [apiState]
    this.apiState.method = "GET";
    this.apiState.url = `${this.$api.servers.sso}/api/v1/en/data/state`;
    this.apiState.callbackReset = () => {
      this.apiState.isLoading = true;
      this.apiState.isError = false;
    };
    this.apiState.callbackError = (e) => {
      this.apiState.isLoading = false;
      this.apiState.isError = true;
      this.apiState.error = e;
    };
    this.apiState.callbackSuccess = (resp) => {
      this.states = [{ text: "All", value: null }];
      resp.forEach((s) => {
        this.states.push({ text: s.name, value: s.value });
      });
    };
    //EOC

    //BOC: [apiEvent]
    this.apiEvent.method = "GET";
    this.apiEvent.url = `${this.$api.servers.event}/api/v1/en/data/event`;
    this.apiEvent.callbackReset = () => {
      this.apiEvent.isLoading = true;
      this.apiEvent.isError = false;
    };
    this.apiEvent.callbackError = (e) => {
      this.apiEvent.isLoading = false;
      this.apiEvent.isError = true;
      this.apiEvent.error = e;
    };
    this.apiEvent.callbackSuccess = (resp) => {
      this.events = [];
      resp.forEach((s) => {
        this.events.push({ text: `${s.name} - ${s.code}`, value: s.code });
      });
      this.selectedEvent = this.events[0].value;
    };
    //EOC

    //BOC: [hardcoded report module for government]
    const governmentInstitutions = JSON.parse(
      process.env.VUE_APP_GOVERNMENT_REPORT_INSTITUTION
    );
    this.governmentInstitution = governmentInstitutions.find(
      (g) => g.id == this.$route.params.id
    );
    if (!this.governmentInstitution)
      this.$router.push({
        name: "PageEducatorInstitutionDashboard",
        params: { id: this.$route.params.id },
      });
    if (this.governmentInstitution.state) {
      this.disableSelectState = true;
      this.selectedState = this.$_.clone(this.governmentInstitution.state);
    }
    //EOC
  },
  mounted() {
    this.$api.fetch(this.apiState);
    this.$api.fetch(this.apiEvent);
  },
  methods: {
    fetchInstitutions() {
      this.api.params = {
        state: this.selectedState,
        institutionType: this.selectedInsitutionType,
      };
      this.$api.fetch(this.api);
    },
    fetchEventReport() {
      this.apiEventReport.params = {
        state: this.selectedState,
        institutionType: this.selectedInsitutionType,
        eventCode: this.selectedEvent,
        enableQuestionCount: false,
      };
      this.$api.fetch(this.apiEventReport);
    },
  },
  watch: {
    activeTab() {
      //
    },
  },
};
</script>
<style scoped></style>